const doc = [({"zh_tw":({"adminComponentHotelChildrenSetting":({"addCategory":"添加類別", "editCategory":"編輯類別", "hotelChildrenSettingTitle":"兒童設定", "notesTitle":"兒童注意事項"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;